import type { Slide } from '../types';

type SlideImage = Slide['image'];

export const japaneseImageOverrides: SlideImage[] = [
  {
    desktop: {
      alt: 'explore_image_alt_1',
      src: 'ja-regional/hp-membership-sleep-4',
    },
    mobile: {
      default: {
        alt: 'explore_image_alt_1',
        src: 'ja-regional/hp-membership-sleep-4',
      },
      overlay: {
        alt: 'explore_image_alt_1',
        src: 'ja-regional/hp-sleep-overlay',
      },
    },
  },
  {
    desktop: {
      alt: 'two_women_looking_at_phone_img_alt',
      src: 'ja-regional/hp-membership-wellness-3',
    },
    mobile: {
      default: {
        alt: 'two_women_looking_at_phone_img_alt',
        src: 'ja-regional/hp-membership-wellness-3',
      },
      overlay: {
        alt: 'two_women_looking_at_phone_img_alt',
        src: 'ja-regional/hp-wellness-overlay',
      },
    },
  },
  {
    desktop: {
      alt: 'man_jogging_img_alt',
      src: 'ja-regional/hp-membership-fitness-3',
    },
    mobile: {
      default: {
        alt: 'man_jogging_img_alt',
        src: 'ja-regional/hp-membership-fitness-3',
      },
      overlay: {
        alt: 'man_jogging_img_alt',
        src: 'ja-regional/hp-activity-overlay',
      },
    },
  },
  {
    desktop: {
      alt: 'man_taking_photo_img_alt',
      src: 'ja-regional/hp-membership-heart-health-2',
    },
    mobile: {
      default: {
        alt: 'man_taking_photo_img_alt',
        src: 'ja-regional/hp-membership-heart-health-2',
      },
      overlay: {
        alt: 'man_taking_photo_img_alt',
        src: 'ja-regional/hp-heart-health-overlay',
      },
    },
  },
  {
    desktop: {
      alt: 'woman_flowers_img_alt',
      src: 'ja-regional/hp-membership-womens-health-2',
    },
    mobile: {
      default: {
        alt: 'woman_flowers_img_alt',
        src: 'ja-regional/hp-membership-womens-health-2',
      },
      overlay: {
        alt: 'woman_flowers_img_alt',
        src: 'ja-regional/hp-womens-health-overlay',
      },
    },
  },
  {
    desktop: {
      alt: 'man_cup_img_alt',
      src: 'ja-regional/hp-membership-stress-2',
    },
    mobile: {
      default: {
        alt: 'man_cup_img_alt',
        src: 'ja-regional/hp-membership-stress-2',
      },
      overlay: {
        alt: 'man_cup_img_alt',
        src: 'ja-regional/hp-stress-overlay',
      },
    },
  },
];
